import { Grid } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { TabTextField } from "../../documentModal/styles/DocumentModal";

const BodyNotIdentified = ({
  documentData,
  listDocuments,
  setListDocuments,
  documentIndex,
  changeDocumentData,
}) => {
  const [description, setDescription] = useState("");

  useEffect(() => {
    setDescription(documentData.description);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onChangeData = (changedProperties) => {
    changeDocumentData({ ...documentData, ...changedProperties });
  };

  return (
    <Grid item xs={12}>
      <TabTextField
        label="Descrição"
        variant="outlined"
        value={description}
        onChange={(ev) => {
          setDescription(ev.target.value);
          onChangeData({ description: ev.target.value });
        }}
      />
    </Grid>
  );
};

export default BodyNotIdentified;
